var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"range",staticClass:"sf-range",attrs:{"type":"range","disabled":_vm.disabled}},[_vm._t("default",null,null,_vm.$attrs)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }